import { createApiClient } from '@terka/api';

const BASE_URL = window.location.hostname === 'localhost'
  ? 'http://localhost:5010/api'
  : '/api';

const webStorage = {
  getAccessToken: () => localStorage.getItem('terka_token'),
  getRefreshToken: () => localStorage.getItem('terka_refresh'),
  setTokens: (access, refresh) => {
    localStorage.setItem('terka_token', access);
    localStorage.setItem('terka_refresh', refresh);
  },
  clearTokens: () => {
    localStorage.removeItem('terka_token');
    localStorage.removeItem('terka_refresh');
  },
};

const api = createApiClient({
  baseUrl: BASE_URL,
  storage: webStorage,
  onUnauthorized: () => window.location.reload(),
});

export const SOCKET_URL = window.location.hostname === 'localhost'
  ? 'http://localhost:5010'
  : window.location.origin;

export default api;
